export default __webpack_public_path__ + "static/media/coin.94543a41.png";